import { z } from "@/zod";

export const STORE_STATUS_ACTIVE = "active";
export const STORE_STATUS_CLOSED = "closed";
export const STORE_STATUS_FRANCHISE = "franchise";

export const STORE_STATUS = [
  STORE_STATUS_ACTIVE,
  STORE_STATUS_CLOSED,
  STORE_STATUS_FRANCHISE,
] as const;

export const storeStatus = z.enum(STORE_STATUS);
export const readStoreStatus = storeStatus.readonly();
export const writeStoreStatus = storeStatus;
